<app-content-page-layout title="Inventory">

</app-content-page-layout>
